//import Cookies from 'js-cookie';

/*
 * This file contains general pourposes functions: header fixed, header nav, header cart, cookies advice, etc.
 */

/* jshint sub:true*/
/* jshint loopfunc:true */

// GET Params
var params = getParams('js-main');
var baseUrl = params.baseUrl;
var section = params.section;


// Vars
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('.js-main-header-wrap').outerHeight();

var KEYCODE_ESC = 27;
var KEYCODE_ENTER = 13;
var KEYCODE_CMD = 91;
var KEYCODE_CMD_RIGHT = 93;
var KEYCODE_CTRL = 17;
var KEYCODE_ALT = 18;
var KEYCODE_C = 67;
var KEYCODE_V = 86;
var KEYCODE_R = 82;
var ctrlDown = false;

var $search = $('.js-search');
var $searchInput = $('.js-search-input');
var searchValPrev = '';
var searchVal = '';

var currentRequest = false;

var myVarTimeout = null;
var lastSearchInputVal = '';




// Photoswipe
function initPhotoswipe() {
    // find nearest parent element
    var closest = function closest(el, fn) {
        return el && (fn(el) ? el : closest(el.parentNode, fn));
    };

    var initPhotoSwipeFromDOM = function (gallerySelector) {

        // parse slide data (url, title, size ...) from DOM elements
        // (children of gallerySelector)
        var parseThumbnailElements = function (el) {
            var thumbElements = el.querySelectorAll(gallerySelector + '-item'),
                numNodes = thumbElements.length,
                items = [],
                linkEl,
                size,
                item;

            for (var i = 0; i < numNodes; i++) {

                linkEl = thumbElements[i]; // <a> element

                // include only element nodes
                if (linkEl.nodeType !== 1) {
                    continue;
                }

                size = linkEl.getAttribute('data-size').split('x');

                // create slide object
                item = {
                    src: linkEl.getAttribute('href'),
                    w: parseInt(size[0], 10),
                    h: parseInt(size[1], 10),
                    title: linkEl.getAttribute('data-caption'),
                };

                if (linkEl.children.length > 1) {
                    item.title = linkEl.getAttribute('data-title');
                }

                // if(linkEl.children.length > 0) {
                //     // <img> thumbnail element, retrieving thumbnail url
                //     item.msrc = linkEl.getAttribute('src');
                // }

                item.el = linkEl; // save link to element for getThumbBoundsFn
                items.push(item);
            }

            return items;
        };

        // triggers when user clicks on thumbnail
        var onThumbnailsClick = function (e) {
            e = e || window.event;
            if (e.preventDefault)
                e.preventDefault();
            else
                e.returnValue = false;

            // e.preventDefault ? e.preventDefault() : e.returnValue = false;

            var eTarget = e.target || e.srcElement;

            // find root element of slide
            var clickedListItem = eTarget.parentNode;
            if (eTarget.classList.contains(gallerySelector.substr(1) + '-item'))
                clickedListItem = eTarget;

            if (!clickedListItem)
                return;

            // find index of clicked item by looping through all child nodes
            // alternatively, you may define index via data- attribute

            var clickedGallery = closest(eTarget, function (el) {
                return (el.classList.contains(gallerySelector.substr(1)));
            }),
                childNodes = clickedGallery.querySelectorAll(gallerySelector + '-item'),
                numChildNodes = childNodes.length,
                nodeIndex = 0,
                index;

            for (var i = 0; i < numChildNodes; i++) {
                if (childNodes[i].nodeType !== 1) {
                    continue;
                }

                if (childNodes[i] === clickedListItem) {
                    index = nodeIndex;
                    break;
                }
                nodeIndex++;
            }

            if (index >= 0) {
                // open PhotoSwipe if valid index found
                openPhotoSwipe(index, clickedGallery);
            }
            return false;
        };

        var openPhotoSwipe = function (index, galleryElement, disableAnimation) {
            var pswpElement = document.querySelectorAll('.pswp')[0],
                gallery,
                options,
                items;

            items = parseThumbnailElements(galleryElement);

            // define options (if needed)
            options = {

                // define gallery index (for URL)
                galleryUID: galleryElement.getAttribute('data-pswp-uid'),

                getThumbBoundsFn: function (index) {
                    // See Options -> getThumbBoundsFn section of documentation for more info
                    var thumbnail = items[index].el.firstElementChild; // find thumbnail
                    if (!thumbnail)
                        thumbnail = items[index].el;

                    var pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                        rect = thumbnail.getBoundingClientRect();

                    return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
                },

                index: 0,
                bgOpacity: 1,
                history: false,
                closeOnScroll: false,
                timeToIdle: 6000,
                // captionEl: false,
                fullscreenEl: false,
                counterEl: false,
                shareEl: false,
                zoomEl: false,
                showHideOpacity: true,
                hideAnimationDuration: 0,
                // showAnimationDuration: 0,
                errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">La imagen</a> no se ha podido cargar.</div>',
                isClickableElement: function (el) {
                    return el.tagName === 'A';
                }

            };

            options.index = parseInt(index, 10);

            // exit if index not found
            if (isNaN(options.index)) {
                return;
            }

            if (disableAnimation) {
                options.showAnimationDuration = 0;
            }

            // Pass data to PhotoSwipe and initialize it
            gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
            gallery.init();

            if (galleryElement.classList.contains(gallerySelector.substr(1) + '-zoom')) {
                gallery.listen('initialZoomInEnd', function () {
                    var zoomLevel = 1;
                    if (breakpoint.value === 'xxs' || breakpoint.value === 'xs') {
                        zoomLevel = 0.5;
                    } else {
                        pswpElement.classList.add('pswp--zoomed-in');
                    }
                    gallery.zoomTo(zoomLevel, { x: gallery.viewportSize.x / 2, y: gallery.viewportSize.y / 2 }, 0, false);
                });
            }
        };

        // loop through all gallery elements and bind events
        var galleryElements = document.querySelectorAll(gallerySelector + '-item');
        var i = 0;
        var l = 0;

        for (i = 0, l = galleryElements.length; i < l; i++) {
            galleryElements[i].setAttribute('data-pswp-uid', i + 1);
            galleryElements[i].onclick = onThumbnailsClick;
        }

        // zoom btn
        var onZoomExternalBtnsClick = function (e) {
            e = e || wisndow.event;
            if (e.preventDefault)
                e.preventDefault();
            else
                e.returnValue = false;

            var eTarget = e.target || e.srcElement;

            var clickedGallery = closest(eTarget, function (el) {
                return (el.classList.contains(gallerySelector.substr(1)));
            });

            items = clickedGallery.querySelectorAll(gallerySelector + '-item');

            for (i = 0, l = items.length; i < l; i++) {
                var index = items[i].getAttribute('data-index');
                if (index === clickedGallery.getAttribute('data-index')) {
                    items[i].click();
                    break;
                }
            }
            // openPhotoSwipe( 0, clickedGallery );
        };

        var zoomExternalBtns = document.querySelectorAll(gallerySelector + '-zoom-btn');

        for (i = 0, l = zoomExternalBtns.length; i < l; i++) {
            zoomExternalBtns[i].onclick = onZoomExternalBtnsClick;
        }


    };

    // execute above function
    initPhotoSwipeFromDOM('.js-pswp');
}

function installersMap() {

    // Create an array of styles.
    var styles = [
        {
            featureType: "administrative.country",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#005183"
                }
            ]
        },
        {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#005183"
                }
            ]
        },
        {
            featureType: "administrative.neighborhood",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#005183"
                }
            ]
        },
        {
            featureType: "administrative.province",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#005183"
                }
            ]
        },
        {
            featureType: "landscape.man_made",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                },
                {
                    weight: 1
                }
            ]
        },
        {
            featureType: "landscape.natural",
            stylers: [
                {
                    color: "#cfdbd8"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#005183"
                },
                {
                    weight: 1
                }
            ]
        },
        {
            featureType: "poi.attraction",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi.business",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi.government",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi.medical",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi.park",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi.place_of_worship",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi.school",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi.sports_complex",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "road.arterial",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#92bed4"
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#dcc896"
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#cb9d3f"
                }
            ]
        },
        {
            featureType: "road.local",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#92bed4"
                }
            ]
        },
        {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#005183"
                }
            ]
        },
        {
            featureType: "transit.station",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "water",
            stylers: [
                {
                    color: "#f2f7fb"
                }
            ]
        },
        {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        }

    ];

    // Create a new StyledMapType object, passing it the array of styles,
    // as well as the name to be displayed on the map type control.
    var styledMap = new google.maps.StyledMapType(styles, { name: "Persax" });

    // Create a map object, and include the MapTypeId to add
    // to the map type control.
    type = $('#installersMap').attr('data-type');
    if (type == 'dealers') {
        level_zoom = $('#installersMap').data('default-zoom');
        center = { lat: 40.415363, lng: -3.707398 }
    }
    else {
        level_zoom = $('#installersMap').data('default-zoom');
        center = { lat: 38.543196, lng: -0.8027 }
    }

    var mapOptions = {
        zoom: level_zoom,
        center: center,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        zoomControl: true,
        scrollwheel: false,
        draggable: true
    };

    var map = new google.maps.Map(document.getElementById('installersMap'), mapOptions);
    var allMarkers = [];
    var markerBounds = new google.maps.LatLngBounds();
    var image = '/build/images/localiza--map--full-single.svg';

    //Associate the styled map with the MapTypeId and set it to display.
    map.mapTypes.set('map_style', styledMap);
    map.setMapTypeId('map_style');

    /*for(i=0; i<markerInstallers.length; i++) {

        marker = new google.maps.Marker({
            position: new google.maps.LatLng(markerInstallers[i]['data']['lat'], markerInstallers[i]['data']['long']),
            icon: image,
            map: map,
            title: 'shop_'+markerInstallers[i]['id'],
        });

        marker.addListener('click', function() {

            $('#modal-shop-container').html($('#'+this.title).html());
            $('#modal-shop').modal('show');
            var title = $('#modal-shop .address_name').html();
            $('#modal-shop #modal-shop-name-container').html(title);
            $('#modal-shop .address_name').hide();

          });

       markerBounds.extend(marker.position);
       allMarkers.push(marker);

    }*/

    //map.fitBounds(markerBounds);


    var clusterStyles = [
        {
            anchor: [-10, 0],
            textAlign: 'center',
            textSize: 12,
            textColor: '#ffffff',
            url: '/build/images/localiza--map--group.svg',
            height: 34,
            width: 24
        },
        {
            anchor: [-10, 0],
            textAlign: 'center',
            textSize: 12,
            textColor: '#ffffff',
            url: '/build/images/localiza--map--group.svg',
            height: 34,
            width: 24
        },
        {
            anchor: [-10, 0],
            textAlign: 'center',
            textSize: 12,
            textColor: '#ffffff',
            url: '/build/images/localiza--map--group.svg',
            height: 34,
            width: 24
        }
    ];
    _mc_options = {
        styles: clusterStyles
    };

    // var markerCluster = new MarkerClusterer(map, allMarkers,
    // {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});
    var markerCluster = new MarkerClusterer(map, allMarkers, _mc_options);

    google.maps.event.addListener(map, 'bounds_changed', function () {

        var actives = 0;

        positionInstallers(map, image, allMarkers);

        for (i = 0; i < allMarkers.length; i++)
            if (map.getBounds().contains(allMarkers[i].getPosition())) { $('#' + allMarkers[i].title).show(); actives++; }
            else { $('#' + allMarkers[i].title).hide(); }

        if (actives <= 0)
            $('#no_installers').show();
        else
            $('#no_installers').hide();


    });



    // Enable scrolling on click event on the map
    /*map.addListener('click', function(){
        map.setOptions({ scrollwheel: true });
    });*/

    // Enable scrolling on drag event on the map
    /*map.addListener('drag', function(){
        map.setOptions({ scrollwheel: true });
    });*/



    // Disable scrolling on mouseout from the map
    map.addListener('mouseout', function () {
        map.setOptions({ scrollwheel: false });
    });

    // Responsive on window resize
    //google.maps.event.addDomListener(window, 'resize', function() {
    //    map.setCenter(mapLatLng);
    //});

    var geocoder = new google.maps.Geocoder();

    document.getElementById('btn_search').addEventListener('click', function () {
        geocodeAddress(geocoder, map);
    });

    if (document.getElementById('search_map').value != "")
        geocodeAddress(geocoder, map);
    else {
        // Defaul and mobile, get GPS
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
            navigator.geolocation.getCurrentPosition(
                function (position) { map.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude)); },
                function (e) { });
    }

    //map.setCenter(new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

}

var httpR = null;
function positionInstallers(_mapa, image, allmarkers) {
    zoom = _mapa.getZoom();

    bounds = _mapa.getBounds();
    center = _mapa.getCenter();

    var NE = bounds.getNorthEast();
    var SW = bounds.getSouthWest();

    var posicion = new google.maps.LatLng(center.lat(), center.lng()); //ponemos las coordenadas

    var endpoint = $('#installersMap').attr('data-url');
    var type = $('#installersMap').attr('data-type');

    httpR = $.ajax({
        method: "POST",
        //url:endpoint+'?'+datos,
        url: endpoint,
        data: { action: type, p1x: SW.lng(), p1y: SW.lat(), p2x: NE.lng(), p2y: NE.lat(), clat: center.lat(), clon: center.lng() },
        responseType: 'json',
        success: function (response) {

            if (response.status == 1) {
                if (response.data.total !== 0) {
                    $('#show_installers').html(response.data.text);
                    addMarkers(_mapa, response.data.info, image, allmarkers);
                } else {
                    _mapa.setZoom(_mapa.getZoom() - 1);
                }

            }
        },
        beforeSend: function (data2) {
            $('.modal').modal('hide');

            if (httpR) {
                httpR.abort();
            }
            httpR = data2;
        },
    });
}

function addMarkers(map, markerInstallers, image, allMarkers) {

    var markerBounds = new google.maps.LatLngBounds();
    for (i = 0; i < markerInstallers.length; i++) {

        marker = new google.maps.Marker({
            position: new google.maps.LatLng(markerInstallers[i]['data']['lat'], markerInstallers[i]['data']['long']),
            icon: image,
            map: map,
            title: 'shop_' + markerInstallers[i]['id'],
        });

        marker.addListener('click', function () {

            $('#modal-shop #modal-shop-container').html($('#' + this.title).html());
            $('#modal-shop').modal('show');
            var title = $('#modal-shop .address_name').html();
            $('#modal-shop #modal-shop-name-container').html(title);
            $('#modal-shop .address_name').hide();

        });

        markerBounds.extend(marker.position);
        allMarkers.push(marker);

    }
}


function geocodeAddress(geocoder, resultsMap) {

    var address = document.getElementById('search_map').value;
    geocoder.geocode({ 'address': address, 'componentRestrictions': { 'country': 'es' } }, function (results, status) {

        if (status === 'OK') {
            resultsMap.setCenter(results[0].geometry.location);

            if ($('#installersMap').length > 0) {
                resultsMap.setZoom(parseInt($('#installersMap').data('default-zoom')));
            }

        } else {
            alert('Geocode was not successful for the following reason: ' + status);
        }
    });
}



function contactMap() {
    var mapLatLng = { lat: 38.573135, lng: -0.844930 };
    // var markerLatLng = {lat: 38.574415, lng: -0.838930};
    var markerLatLng = { lat: 38.574315, lng: -0.838910 };

    // Create an array of styles.
    var styles = [
        {
            featureType: "administrative.country",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#005183"
                }
            ]
        },
        {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#005183"
                }
            ]
        },
        {
            featureType: "administrative.neighborhood",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#005183"
                }
            ]
        },
        {
            featureType: "administrative.province",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#005183"
                }
            ]
        },
        {
            featureType: "landscape.man_made",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                },
                {
                    weight: 1
                }
            ]
        },
        {
            featureType: "landscape.natural",
            stylers: [
                {
                    color: "#cfdbd8"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "labels",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#005183"
                },
                {
                    weight: 1
                }
            ]
        },
        {
            featureType: "poi.attraction",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi.business",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi.government",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi.medical",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi.park",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi.place_of_worship",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi.school",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "poi.sports_complex",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "road.arterial",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#92bed4"
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#dcc896"
                }
            ]
        },
        {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [
                {
                    color: "#cb9d3f"
                }
            ]
        },
        {
            featureType: "road.local",
            elementType: "geometry.fill",
            stylers: [
                {
                    color: "#92bed4"
                }
            ]
        },
        {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [
                {
                    color: "#005183"
                }
            ]
        },
        {
            featureType: "transit.station",
            elementType: "geometry.fill",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        },
        {
            featureType: "water",
            stylers: [
                {
                    color: "#f2f7fb"
                }
            ]
        },
        {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [
                {
                    visibility: "off"
                }
            ]
        }

    ];

    // Create a new StyledMapType object, passing it the array of styles,
    // as well as the name to be displayed on the map type control.
    var styledMap = new google.maps.StyledMapType(styles, { name: "Persax" });

    // Create a map object, and include the MapTypeId to add
    // to the map type control.
    var mapOptions = {
        zoom: 15,
        center: mapLatLng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        scrollwheel: false,
        draggable: false
    };

    var map = new google.maps.Map(document.getElementById('map'), mapOptions);

    //Associate the styled map with the MapTypeId and set it to display.
    map.mapTypes.set('map_style', styledMap);
    map.setMapTypeId('map_style');

    var image = '/build/images/localiza--map--brand.svg';

    var marker = new google.maps.Marker({
        position: markerLatLng,
        icon: image,
        map: map
    });


    // Enable scrolling on click event on the map
    map.addListener('click', function () {
        map.setOptions({ scrollwheel: true });
    });

    // Enable scrolling on drag event on the map
    map.addListener('drag', function () {
        map.setOptions({ scrollwheel: true });
    });

    // Disable scrolling on mouseout from the map
    map.addListener('mouseout', function () {
        map.setOptions({ scrollwheel: false });
    });

    // Responsive on window resize
    google.maps.event.addDomListener(window, 'resize', function () {
        map.setCenter(mapLatLng);
    });


}




// Window scroll
function windowScroll() {

    //if (breakpoint.value != 'xxs' && breakpoint.value != 'xs' && breakpoint.value != 'sm') {
    if ($(window).scrollTop() > 30) {
        $('.js-main-header').addClass('is-mini');
        $('body').addClass('is-header-mini');
    } else {
        $('.js-main-header').removeClass('is-mini');
        $('body').removeClass('is-header-mini');
    }

    if ($(window).scrollTop() > 200) {
        $('.js-main-header-iframe').addClass('is-mini');
    } else {
        $('.js-main-header-iframe').removeClass('is-mini');
    }
    //}

}


// Nav mobile
function toggleNavMobile() {
    $('body').toggleClass('is-nav-mobile-open');
}


function navMobile() {
    $('.js-nav-mobile-trigger').on('click', function () {
        toggleNavMobile();
    });

    $('.js-nav-mobile-link').on('click', function (e) {
        var item = $(this).closest('.js-nav-mobile-item');
        var icon = $(this).find('.icon__plus');
        var subnav = item.find('.js-subnav-mobile');

        if (subnav.length > 0) {
            e.preventDefault();
            $('.icon__plus').removeClass('icon__plus--minus');

            if (item.hasClass('is-open')) {
                item.removeClass('is-open');
                icon.removeClass('icon__plus--minus');
            } else {
                $('.js-nav-mobile-item').removeClass('is-open');
                item.addClass('is-open');
                icon.addClass('icon__plus--minus');
            }
        }
        // icon.toggleClass('icon__plus--minus');
    });

    $('.js-nav-mobile-link--second').on('click', function (e) {
        var item = $(this).closest('.js-nav-mobile-item--second');
        var icon = $(this).find('.icon__plus');
        var subnav = item.find('.js-subnav-mobile--second');

        if (subnav.length > 0) {
            e.preventDefault();
            $('.js-nav-mobile-link--second .icon__plus').removeClass('icon__plus--minus');

            if (item.hasClass('is-open')) {
                item.removeClass('is-open');
                icon.removeClass('icon__plus--minus');
            } else {
                $('.js-nav-mobile-item--second').removeClass('is-open');
                item.addClass('is-open');
                icon.addClass('icon__plus--minus');
            }
        }
    });
}




// Search
function search() {

    // extending the jQuery prototype with setCursorPosition
    $.fn.setCursorPosition = function (pos) {
        this.each(function (index, elem) {
            if (elem.setSelectionRange) {
                elem.setSelectionRange(pos, pos);
            } else if (elem.createTextRange) {
                var range = elem.createTextRange();
                range.collapse(true);
                range.moveEnd('character', pos);
                range.moveStart('character', pos);
                range.select();
            }
        });
        return this;
    };

    $searchInput.on('keydown', function (e) {
        searchValPrev = $searchInput.val();
    }).on('keyup', function (e) {
        searchVal = $searchInput.val();
        if (searchVal != searchValPrev)
            searchAction();
    });

    $(document).on('keydown', function (e) {
        if (e.keyCode == KEYCODE_CTRL || e.keyCode == KEYCODE_CMD || e.keyCode == KEYCODE_CMD_RIGHT)
            ctrlDown = true;

        // Search is opened
        if ($search.is(':visible')) {
            if (e.which == KEYCODE_ESC) {
                searchClose();
                $searchInput.trigger('blur');
            } else if (
                ((e.which >= 48 && e.which <= 90) || (e.which >= 96 && e.which <= 105)) ||
                (e.shiftKey === true && ((e.which >= 48 && e.which <= 90) || (e.which >= 96 && e.which <= 105)))
            ) {
                $searchInput.trigger('focus');
                //searchAction();
            }
        }
        // Search is closed
        else {
            if (ctrlDown && (e.keyCode == KEYCODE_V || e.keyCode == KEYCODE_C || e.keyCode == KEYCODE_R)) {

            } else {
                var inputType = e.target.nodeName.toLowerCase();
                if (inputType != 'input' && inputType != 'textarea' && inputType != 'select') {
                    if (
                        ((e.which >= 48 && e.which <= 90) || (e.which >= 96 && e.which <= 105)) ||
                        (e.shiftKey === true && ((e.which >= 48 && e.which <= 90) || (e.which >= 96 && e.which <= 105)))
                    ) {
                        $searchInput.trigger('focus');

                        // grab the key pressed ( String.fromCharCode(e.which) )
                        // and insert it into $searchInput.
                        // then,set the cursor to the end of $searchInput.
                        searchValPrev = $searchInput.val();
                        $searchInput.val(String.fromCharCode(e.which).toLowerCase());

                        window.setTimeout(function () {
                            $searchInput.setCursorPosition($searchInput.val().length);
                        }, 0);

                        searchVal = $searchInput.val();
                        searchOpen();
                    }
                }
            }
        }

    }).on('keyup', function (e) {
        if (e.keyCode == KEYCODE_CTRL || e.keyCode == KEYCODE_CMD || e.keyCode == KEYCODE_CMD_RIGHT)
            ctrlDown = false;
    });

    $('.js-search-close').on('click', function () {
        searchClose();
    });
}


function searchOpen() {
    // Buscador desktop
    if (!Modernizr.touchevents) {

        if (!$('.js-search').is(':visible')) {
            $('body').addClass('is-blocked');
            $('.js-search-results, .js-search-loading, .js-search-msg, .js-search-list').hide();

            searchAction();

            // $('.js-search-backdrop').show();
            $('.js-search-backdrop').show();
            $('.js-search').fadeIn(250, function () {
                // $('body').addClass('is-blocked');

                // if (mobileDetect.is('iOS'))
                //     $searchInput.attr('placeholder', 'Escribe aqu�');

                $searchInput.trigger('focus');
            });
        }

    } else {
        // Buscador dispositivos t�ctiles
        if (!$('.js-search-mini').hasClass('is-always-open')) {
            $('body').toggleClass('is-search-mini-open');
            $('.js-search-mini').toggleClass('is-open');

            if ($('.js-search-mini').hasClass('is-open')) {
                $('.js-search-mini-input:eq(0)').trigger('focus');
            }
        } else {
            $('.js-search-mini-input:eq(0)').trigger('focus');
        }
    }
}


function searchClose() {
    $('body').removeClass('is-blocked');
    $('.js-search, .js-search-backdrop').fadeOut(250);
}


function searchAction() {
    $('.js-search-subtitle').css('opacity', 1);
    $('.js-search-results, .js-search-loading, .js-search-msg, .js-search-list').hide();

    if ($searchInput.val() !== '' && $searchInput.val().length >= 3) {
        // $('.js-search-backdrop').show();
        // alert($searchInput.val());

        $('.js-search-subtitle').css('opacity', 0);
        $('.js-search-main').show();
        $('.js-search-results, .js-search-loading').show();

        clearTimeout(myVarTimeout);

        // AJAX Call
        // myVarTimeout = setTimeout(function()
        // {
        if (currentRequest) {
            currentRequest.abort();
            currentRequest = false;
            $('.js-search-loading').show();
            $('.js-search-msg, .js-search-list').hide();
        }

        _action_search = $("#action_search").val();

        lastSearchInputVal = $searchInput.val();

        currentRequest = $.post(_action_search, { q: lastSearchInputVal, action: 'search' }, function (resp) {
            if (lastSearchInputVal == $searchInput.val()) {
                $('.js-search-loading').hide();
                $('.js-search-msg, .js-search-list').show();
                $('.js-search-list').html(resp.data.search_result);
                $('.js-search-msg').html(resp.data.search_text);
            }
        });
        // }, 1000);

    } else {
        // $('.js-search-main, .js-search-backdrop').fadeOut(250);
        $('.js-search-main').fadeOut(250);
    }
}

function ajax_form(e) {
    e.preventDefault();
    $("#register_send").prop("disabled", true);

    form = $(this);
    url = $(this).attr('action');
    var text_correct = $(this).attr('data-text-correct');
    $(text_correct).removeClass('validate__message--error').removeClass('validate__message--correct').hide();

    var formData = new FormData(form[0])
    $.ajax(
        {
            url: url,
            type: 'POST',
            data: formData,
            async: true,
            cache: false,
            contentType: false,
            processData: false,


            success: function (data) {
                if (data.status === true) {
                    form.find('input:text, input:password, textarea').val('').blur();
                    form.find('input:checkbox').removeAttr('checked');


                    switch (data.action) {
                        case 'print':
                            if (text_correct !== undefined && data.data.text !== undefined) {
                                $(text_correct).addClass('validate__message--correct');
                                $(text_correct).html(data.data.text);
                                $(text_correct).show();

                                var top = $(text_correct).offset().top - $('.main-header').height() - 20;
                                $('html, body').scrollTop(top);
                            }
                            break;

                        case 'printDescarga':
                            if (text_correct !== undefined && data.data.text !== undefined) {
                                $('#descarga_form').hide();
                                $(text_correct).addClass('validate__message--correct');
                                $(text_correct).html(data.data.text);
                                $(text_correct).show();

                                var top = $(text_correct).offset().top - $('.main-header').height() - 20;
                                $('html, body').scrollTop(top);
                            }
                            break;


                        case 'errorRegistro':
                            if (text_correct !== undefined && data.data.text !== undefined) {
                                $('#descarga_form').hide();
                                $(text_correct).addClass('validate__message--error');
                                $(text_correct).html(data.data.text);
                                $(text_correct).show();

                                var top = $(text_correct).offset().top - $('.main-header').height() - 20;
                                $('html, body').scrollTop(top);
                            }
                            $("#register_send").prop("disabled", false);
                            break;

                        case 'errorLogin':
                            $('#show_message_login').addClass('validate__message--error');
                            $('#show_message_login').html(data.data.text);
                            $('#show_message_login').show();
                            $("#register_send").prop("disabled", false);
                            break;

                        case 'exitoRegistro':
                            document.getElementById('close_modal').click();
                            document.getElementById('click-correct-register').click();
                            $("#register_send").prop("disabled", false);
                            $('html, body').scrollTop(top);
                            break;

                        case 'reloadPage':
                            location.reload();
                            break;

                        case 'redirect':
                            if (data.redirect !== undefined) {
                                window.location.replace(data.redirect);
                            }
                            break;
                    }
                }
                else {
                    switch (data.action) {
                        case 'print':
                            if (text_correct !== undefined && data.data.text !== undefined) {
                                $(text_correct).addClass('validate__message--error');
                                $(text_correct).html(data.data.text);
                                $(text_correct).show();
                                var top = $(text_correct).offset().top - $('.main-header').height() - 20;
                                $('html, body').scrollTop(top);
                            }
                            break;
                        case 'errors':
                            $.each(data.data.errors, function (i, item) {
                                window.ParsleyUI.removeError(form.find('[name="' + i + '"]').parsley(), "error");
                                window.ParsleyUI.addError(form.find('[name="' + i + '"]').parsley(), "error", item);
                            });
                            break;
                    }

                }
            }
        });

    return false;
}




// Select2
function initCustomSelect() {
    $('.js-custom-select').select2({
        minimumResultsForSearch: Infinity
    });
}

$(document).ready(function () {

    /*   $(".js-main-nav-item ").hover(function() {
           $(this).find(".img-source-js").each(function() {
               var img = $(this).data("img");
               if ( img.length > 0 ) $("body").append("<img class='lazy' data-src='"+img+"' style='display:none;'/>");
           });
       });
   
       $(this).find(".img-source-menu-js").each(function() {
           var img = $(this).data("img");
           if ( img.length > 0 ) $("body").append("<img class='lazy' data-src='"+img+"' style='display:none;'/>");
       }); */
});


// Document ready
$(document).ready(function () {

    $('.lazy').lazy();

    // Inicio Select2
    initCustomSelect();

    initPhotoswipe();


    // Lorem
    if (typeof app !== 'undefined') {
        app.addClassIfNotEmptyInput();
    }


    // Window scroll
    windowScroll();

    $(window).on('scroll', function () {
        windowScroll();
    });


    // Nav Mobile
    navMobile();

    // Autocomplete address
    $("#search_map").each(function (index) {
        new google.maps.places.Autocomplete((document.getElementById('search_map')), { types: ['geocode'] });
    });


    // Search
    search();


    // Contact Map
    if (section === 'contact') {
        contactMap();
    }
    if (section === 'installers') {
        installersMap();
    }


    if (section === 'home') {
        $carousel_home = $('.main-carousel').flickity({
            // options
            // cellAlign: 'left',
            autoPlay: 3500,
            pauseAutoPlayOnHover: true,
            contain: true,
            wrapAround: true,
        });
        setTimeout(function () {
            var instance_lazy = $('.lazy').data("plugin_lazy");
            instance_lazy.force('.lazy-highligh');
        }, 1000);

    }


    if (section === 'product') {
        $carousel_product = $('.product-carousel').flickity({
            // options
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
        });

        setTimeout(function () {
            var instance_lazy = $('.lazy').data("plugin_lazy");
            instance_lazy.force('.lazy-highligh');
        }, 1000);
    }

    if (getCookie('ps_cookies_aceptadas') == "") {
        $('.js-cookies-alert').show();
    } else {
        $('.js-cookies-alert').hide();
    }

    // COOKIES
    $('.js-cookies-close').on('click', function (event) {
        $('.js-cookies-alert').hide();
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + 3650);
        var c_value = escape(1) + ((3650 === null) ? "" : "; expires=" + exdate.toUTCString());
        document.cookie = 'ps_cookies_aceptadas' + "=" + c_value;
        location.reload();
    });

    $('.js-cookies-reject').on('click', function (event) {
        $('.js-cookies-alert').hide();
        if (window.ga) window.ga('remove');
        // Remove the default cookies
        // _ga is used to distinguish users.
        Cookies.remove('_ga', { path: '/', domain: 'persax.es' });
        // _gid is used to distinguish users.
        Cookies.remove('_gid', { path: '/', domain: 'persax.es' });
        // _gat is used to throttle request rate.
        Cookies.remove('_gat', { path: '/', domain: 'persax.es' });
    });

    $('form.ajax').submit(ajax_form);





    'use strict';

    ; (function (document, window, index) {
        var inputs = document.querySelectorAll('.inputfile');
        Array.prototype.forEach.call(inputs, function (input) {
            var label = input.nextElementSibling,
                labelVal = label.innerHTML;

            input.addEventListener('change', function (e) {
                var fileName = '';
                if (this.files && this.files.length > 1) {
                    fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                } else {
                    fileName = e.target.value.split('\\').pop();
                }

                if (fileName) {
                    jQuery(this).parent('.form-group--file').addClass('form-group--file--selected');
                    label.querySelector('span').innerHTML = fileName;
                } else {
                    jQuery(this).parent('.form-group--file').removeClass('form-group--file--selected');
                    label.innerHTML = labelVal;
                }
            });

            // Firefox bug fix
            input.addEventListener('focus', function () { input.classList.add('has-focus'); });
            input.addEventListener('blur', function () { input.classList.remove('has-focus'); });
        });
    }(document, window, 0));






});
// END Document ready











































$('.show-more-js').on('click', function (e) {
    $('.product__info').toggleClass('product__info--expanded');
    $('.icon__plus').toggleClass('icon__plus--minus');

    e.preventDefault();
    var item = $(this).attr('href');
    $(item).slideToggle(600);
});







function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}





function _addFormGroupFocus(element) {
    var $element = $(element);
    if (!$element.prop('disabled')) {                                   // this is showing as undefined on chrome but works fine on firefox??
        $element.closest(".form-group").addClass("is-focused");
    }
}


function _toggleTypeFocus($input) {
    $input.closest('label').hover(function () {
        var $i = $(this).find('input');
        if (!$i.prop('disabled')) {                                     // hack because the _addFormGroupFocus() wasn't identifying the property on chrome
            _addFormGroupFocus($i);                                     // need to find the input so we can check disablement
        }
    }, function () {
        _removeFormGroupFocus($(this).find('input'));
    });
}


function _removeFormGroupFocus(element) {
    $(element).closest(".form-group").removeClass("is-focused");        // remove class from form-group
}


$(document)
    .on("change", ".checkbox input[type=checkbox]", function () {
        $(this).blur();
    })
    .on("keydown paste", ".form-control", function (e) {
        // if (_isChar(e)) {
        // $(this).closest(".form-group").removeClass("is-empty");
        $(this).closest(".form-group").addClass("is-full");
        // }
    })
    .on("keyup change", ".form-control", function () {
        var $input = $(this);
        var $formGroup = $input.closest(".form-group");
        var isValid = (typeof $input[0].checkValidity === "undefined" || $input[0].checkValidity());

        if ($input.val() === "") {
            // $formGroup.addClass("is-empty");
            $formGroup.removeClass("is-full");
        }
        else {
            // $formGroup.removeClass("is-empty");
            $formGroup.addClass("is-full");
        }
    })

    .on("focus", ".form-control", function () {
        _addFormGroupFocus(this);
    })
    .on("blur", ".form-control, .form-group.is-fileinput", function () {
        _removeFormGroupFocus(this);
        var $input = $(this);
        var $formGroup = $input.closest(".form-group");
        if ($input.val() === "") {
            // $formGroup.addClass("is-empty");
            $formGroup.removeClass("is-full");
        }
        else {
            // $formGroup.removeClass("is-empty");
            $formGroup.addClass("is-full");
        }
    });





$(document).ready(function () {
    $("#telefono").keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
            // Allow: Ctrl/cmd+A
            (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: Ctrl/cmd+C
            (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: Ctrl/cmd+X
            (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    });
});

$('#register_send').click(function () {
    if ($('#typeClient').val() != 1) {
        if ($("select#type_conocido").val() == '') {
            $(".form_instalador_no_cliente .select2-selection").css('border-color', '#c00');
        } else {
            $(".form_instalador_no_cliente .select2-selection").css('border-color', '');
        }
    }
});

$('#type_contact').change(function () {
    var valorCambiado = $(this).val();
    if ((valorCambiado == 'profesional')) {
        $("#campo_empresa").show();
    }
    else {
        $('#campo_empresa').hide();
    }
});

$('#registro').click(function () {
    $('#seccion_form_registro').hide();
    $('#seccion_registro').hide();
    $('#seccion_tipo').show();
});

$('#volver-principio').click(function () {
    $('#seccion_form_registro').hide();
    $('#seccion_registro').show();
    $('#descarga_form').show();
    $('#seccion_tipo').hide();
    $('#titulo_instaladores').hide();
    $('.form_instalador_no_cliente').hide();
    $('#titulo_instaladores_no_clientes').hide();
    $('.form_tecnico').hide();
    $('#titulo_tecnicos').hide();
});

$('#close_modal').click(function () {
    $('#mensaje-modal').show();
    $('#seccion_form_registro').hide();
    $('#seccion_registro').hide();
    $('#descarga_form').show();
    $('#seccion_tipo').hide();
    $('#titulo_instaladores').hide();
    $('.form_instalador_no_cliente').hide();
    $('#titulo_instaladores_no_clientes').hide();
    $('.form_tecnico').hide();
    $('#titulo_tecnicos').hide();
});

$('#close_modal2').click(function () {
    window.scrollTo(0, 0);
});

$('#volver-eleccion').click(function () {
    $('#seccion_form_registro').hide();
    $('#seccion_registro').hide();
    $('#descarga_form').hide();
    $('#seccion_tipo').show();
    $('#titulo_instaladores').hide();
    $('.form_instalador_no_cliente').hide();
    $('#titulo_instaladores_no_clientes').hide();
    $('.form_tecnico').hide();
    $('#titulo_tecnicos').hide();
    $('#registro_form').trigger("reset");
    $('.is-full').removeClass('is-full');
});

$('#close_modal_no_email').click(function () {
    $('#modal-no-email').hide();
});

$('#close_modal_email_exists').click(function () {
    $('#modal-email-exists').hide();
});

$('#close_modal_changed_email').click(function () {
    $('#modal-changed-email').hide();
});

$('#close_modal_tarifas_b2b').click(function () {
    $('#modal-tarifas-b2b').hide();
});

var b2b_user = $('#b2b_user').val();
if (b2b_user == 1) {
    $('#modal-tarifas-b2b').show();
}

$('#close_modal_email_b2b').click(function () {
    $('#modal-email-b2b').hide();
});

$('#bienvenida-modal').click(function () {
    $('#seccion_registro').show();
    $('#mensaje-modal').hide();
});

$('#square_instalador').click(function () {
    $('#seccion_registro').hide();
    $('#seccion_tipo').hide();
    $('#seccion_form_registro').show();
    $('#titulo_instaladores').show();
});

$('#square_instalador_no_cliente').click(function () {
    $('#seccion_registro').hide();
    $('#seccion_tipo').hide();
    $('#seccion_form_registro').show();
    $('.form_instalador_no_cliente').show();
    $('.form_tecnico').hide();
    $('#titulo_instaladores_no_clientes').show();
});

$('#square_tecnicos').click(function () {
    $('#seccion_registro').hide();
    $('#seccion_tipo').hide();
    $('#seccion_form_registro').show();
    $('.form_instalador_no_cliente').show();
    $('.form_tecnico').show();
    $('#titulo_tecnicos').show();
});


function typeClient(id) {
    $('.required-type-client').attr('required', false);
    $('#typeClient').val(id);
    if (id == 1) {
        $('#seccion_registro').hide();
        $('#seccion_tipo').hide();
        $('#seccion_form_registro').show();
        $('#titulo_instaladores').show();
        $('.required-type-client').attr('required', false);
    } else if (id == 2) {
        $('#seccion_registro').hide();
        $('#seccion_tipo').hide();
        $('#seccion_form_registro').show();
        $('.form_instalador_no_cliente').show();
        $('.form_tecnico').hide();
        $('#titulo_instaladores_no_clientes').show();
        $('#type_conocido.required-type-client').attr('required', true);
    } else {
        $('#seccion_registro').hide();
        $('#seccion_tipo').hide();
        $('#seccion_form_registro').show();
        $('.form_instalador_no_cliente').show();
        $('.form_tecnico').show();
        $('#titulo_tecnicos').show();
        $('.required-type-client').attr('required', true);
    }
}

$('.olvide-contrasena').click(function () {

    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if ($('#user').val() == '' || !regex.test($('#user').val())) {
        $('#modal-no-email').show();
        return;
    }
    var base_url = $('#base_url').val();
    var parametros = {
        "email": $('#user').val(),
        "market": $('#market_email').val(),
        "lang": $('#lang_email').val(),
        "action": "recordarContrasena"
    };
    $.ajax({
        data: parametros, //datos que se envian a traves de ajax
        url: base_url + 'ajax', //archivo que recibe la peticion
        type: 'post', //método de envio
        beforeSend: function () {
            // $("#resultado").html("Procesando, espere por favor...");
        },
        success: function (response) { //una vez que el archivo recibe el request lo procesa y lo devuelve

            if (response == 'emailb2b') {
                $('#modal-email-b2b').show();
            } else if (response == 'emailNoExists') {
                $('#modal-email-exists').show();
            } else {
                $('#modal-changed-email').show();
            }


            // $("#resultado").html(response);
        }
    });
});

$(".img-source-js").hover(function () {
    var img = $(this).data("img");
    var div = $(this).closest(".js-main-nav-item ").find(".img-background-js");
    var menu = $(this).closest(".js-main-nav-item ").find(".img-source-menu-js");
    var menu_img = menu.data("img");
    if (img.length > 0) {
        div.css("background-image", "url(" + img + ")");
    } else {
        if (menu_img.length > 0) {
            div.css("background-image", "url(" + menu_img + ")");
        }
    }
});



$(".img-source-menu-js").hover(function () {
    var img = $(this).data("img");
    var div = $(this).closest(".js-main-nav-item ").find(".img-background-js");

    if (img.length > 0) {
        div.css("background-image", "url(" + img + ")");
    }
});


window.Parsley
    .addValidator('birthday_es', {
        requirementType: 'string',
        validateString: function (value, requirement) {
            var regEx = /^\d{2}\/\d{2}\/\d{4}$/;
            if (value.match(regEx) != null) {
                var info_date = value.split('/');
                var timestamp = new Date(info_date[2], parseInt(info_date[1] - 1), info_date[0]);

                return !isNaN(timestamp) && (timestamp.getDate() == parseInt(info_date[0]) && (timestamp.getMonth() + 1) == parseInt(info_date[1]) && timestamp.getFullYear() == parseInt(info_date[2]));
            }
            else {
                return false;
            }


        },
        messages: {
            es: 'Fecha invalida'
        }
    });




/*
$('.main-subnav').mouseover(function() {
    $('body').css('overflow','hidden');
});
$('.main-subnav').mouseout(function() {
    $('body').css('overflow','inherit');
});
*/
